import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevronLeft",
  "use": "icon_chevronLeft-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_chevronLeft\"><path fill=\"currentColor\" d=\"M12.506 22.445L30.308 4.645a2.198 2.198 0 013.109 0l2.076 2.076c.857.857.859 2.246.004 3.105L21.389 24l14.108 14.175c.855.859.853 2.248-.004 3.105l-2.076 2.076a2.198 2.198 0 01-3.11 0l-17.8-17.801a2.199 2.199 0 010-3.11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol